import { render, staticRenderFns } from "./DistribuidoraField.vue?vue&type=template&id=8984339c&scoped=true&"
import script from "./DistribuidoraField.vue?vue&type=script&lang=js&"
export * from "./DistribuidoraField.vue?vue&type=script&lang=js&"
import style0 from "./DistribuidoraField.vue?vue&type=style&index=0&id=8984339c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8984339c",
  null
  
)

export default component.exports